const KEY = 'pf_lead_source';

export function captureLeadSource() {
  try {
    const p = new URLSearchParams(window.location.search);
    const utm = (p.get('utm_source') || '').toLowerCase();
    let source = null;
    if (p.get('fbclid') || ['facebook', 'fb', 'instagram', 'meta'].includes(utm)) source = 'meta';
    else if (p.get('gclid') || p.get('gbraid') || p.get('wbraid') || ['google', 'adwords', 'googleads'].includes(utm)) source = 'google';
    if (source) sessionStorage.setItem(KEY, source);
  } catch {}
}

export function getLeadSource() {
  try {
    return sessionStorage.getItem(KEY) || 'direct';
  } catch {
    return 'direct';
  }
}
